module.exports = __webpack_public_path__ + "img/phonemobile.a9e26b21.svg";